import { Link } from 'react-router';
import Functions from '../../../functions';
import iconFile from '../../assets/images/icon_presentation.gif';
import type { ItemPresentation } from '../../lib/ItemUtil';
import ListBase, { type ListBaseProps } from '../lib/ListBase';
import PresentationUtil from './PresentationUtil';

class PresentationList extends ListBase {
    constructor(props: ListBaseProps) {
        super(props);
        this.label = 'Presentation';
        this.icon = iconFile;
    }

    renderBody() {
        const { lang } = this.props;
        const item = this.props.item as ItemPresentation;
        const authors = item.creator.map((author) => Functions.mlang(author, lang)).join(', ');
        return (
            <>
                <Link to={this.url}>{Functions.mlang(item.title, lang)}</Link>
                <br />
                <PresentationUtil.PresentationType lang={lang} type={item.presentation_type} />
                <br />
                {authors}
            </>
        );
    }
}

export default PresentationList;
